<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<div class="container" *ngIf="data" style="margin-top:60px">
  <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4  text-left">
      <div class="card" style="border: none">
        <div class="card-body">
          <div style="width:auto;">
            <img src="https://passport.petcart.in/images/prodimgs/{{data.image}}" style="height:400px;">
          </div>
          </div>
      </div>
      <div *ngIf="ppinventory && ppinventory.length>0 && this.ppinventory[0].qty>0">
        <p style="color:red; overflow-wrap:break-word">
            Currently we have only ({{this.ppinventory[0].qty}}) of this item in stock. So please modify the quantity and try
            again.
        </p>
    </div>
    <div *ngIf="ppinventory && ppinventory.length>0 && this.ppinventory[0].qty===0">
      <p style="color:red; overflow-wrap:break-word">
        Currently This item is out of stock.
      </p>
  </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-8 col-xl-8">
      <div class="row" style="padding-left:25px">
        <div class="col-12" style="font-style: open sans">
            <div class="pa-1">
                <div class="product-detail-header">
                  <h3 class="ma-0 pa-0" style="color:#9b7544"><strong>{{ data.name }}</strong></h3>
                </div>
                <h4 class="mat-text-primary mt-1" *ngIf="data.splprice === 0; ">
                    <span style="color:#9b7544"> Rs. {{ data.price }}</span>
                </h4>
                <p style="font-style: open sans; color: #cb983f;
                overflow-wrap: break-word;  font-size:20px" *ngIf="data.splprice > 0;">
                <del style="color:#c5c5c5">Rs. {{ data.price }}</del>
                <br>
                <span style="font-size:20px; float:center; font-weight:bold;">Rs. {{ data.splprice }}</span></p>
                    <p *ngIf="status==1; else outofstock"> Qty:
                        <button style="background-color:transparent;"  (click)='SubMethod()'><mat-icon style="color:#9b7544">remove_circle_outline</mat-icon></button>
                       <span style="color:#9b7544">{{ qt}}</span>
                  <button style="background-color:transparent;" (click)='AddMethod()'><mat-icon style="color:#9b7544">add_circle</mat-icon></button>

                        <button  style="margin-left:13px" class=" btn btn-secondary mr-1" *ngIf="status==1; else outofstock" class="cartbtn" (click)="addToCart()">Add to cart</button>
                          </p>
        </div>
      </div>
    </div>
    <div class="row" style="padding-left:25px">
        <div class="col-12">
            <div class="pa-1" style="font-style: open sans;">
                <div [innerHTML]="data.description" class="description">
              </div>
        </div>
      </div>
    </div>
   </div>
   </div>

 <div class="row" *ngIf="data">
   <div class="col-12">
      <mat-tab-group>
          <mat-tab  label="Feeding Info" *ngIf="data.feedinginfo">
              <div class="row">
                  <div class="col-12">
                      <div fxFlex.gt-md="60" fxFlex.gt-sm="50" fxFlex="100" class="pa-1" style="font-style: open sans;
                      color: #9b7544;">
                          <div [innerHTML]="data.feedinginfo" class="description">
                        </div>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab  label="Nutrition Info" *ngIf="data.nutritioninfo">
                <div class="row">
                    <div class="col-12">
                        <div fxFlex.gt-md="60" fxFlex.gt-sm="50" fxFlex="100" class="pa-1" style="font-style: open sans;
                        color: #9b7544;">
                            <div [innerHTML]="data.nutritioninfo" class="description">
                          </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab  label="Usage Info" *ngIf="data.usageinfo">
                  <div class="row">
                      <div class="col-12">
                          <div fxFlex.gt-md="60" fxFlex.gt-sm="50" fxFlex="100" class="pa-1" style="font-style: open sans;
                          color: #9b7544;">
                              <div [innerHTML]="data.usageinfo" class="description">
                            </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
      </mat-tab-group>
   </div>
 </div>
</div>
<div class="footer">
    <app-footer></app-footer>
</div>
<ng-template #outofstock >
<div class="label" >
    <h5><label class="cartoutstock">Out Of Stock</label></h5></div>
</ng-template>
